import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import ImageUpload from './ImageUpload'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ImagesFormData, InstallationStatementType } from '../../models/images'
import { FormStepProps } from 'src/Libs/installation-statement/components/types'
import { Formik } from 'formik'
import useImageValidation from 'src/Libs/installation-statement/hooks/validation/use-image-validation'

/**
 * Component for the installation statement wizard images step
 */
const Images: React.FC<FormStepProps<ImagesFormData>> = ({ data, setFormData, setFinalValidation, setTouched }) => {
  const { t } = useCustomTranslation()
  const { finalValidationSchema, inProgressValidationSchema } = useImageValidation()
  const combinedFileSize = Object.values(data.images).reduce((accumulator, value) => accumulator + (value.size || 0), 0)

  const handleValidationForFinalValidationSchema = async (values: ImagesFormData): Promise<void> => {
    const response = await finalValidationSchema.isValid(values)
    setFinalValidation(response)
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ pb: 2 }}>
        {t('installation-statement.images.title')}
      </Typography>
      <Typography variant="subtitle2" sx={{ pb: 2 }}>
        {t('installation-statement.images.description')}
      </Typography>

      <Formik
        initialValues={data}
        validationSchema={inProgressValidationSchema}
        onSubmit={() => {
          /* */
        }}
      >
        {formData => {
          if (formData.dirty) {
            setTouched(true)
          }

          setFormData(formData)
          handleValidationForFinalValidationSchema(formData.values)

          return (
            <Grid container spacing={2}>
              {(Object.keys(data.images) as Array<keyof typeof data.images>).map(type => (
                <Grid key={type} item sm={4} xs={12}>
                  <ImageUpload
                    imageType={type as InstallationStatementType}
                    installationId={data.installationId}
                    deviceLinkId={data.deviceLinkId}
                    previewUrl={data.images[type].previewUrl}
                    fileId={data.images[type].id}
                    required={data.images[type].required}
                    combinedFileSize={combinedFileSize}
                  />
                </Grid>
              ))}
            </Grid>
          )
        }}
      </Formik>
    </Box>
  )
}

export default Images
